export const ActionEventTypeEnum = {
  DATA_INGEST_ERROR: 0,
  NODE_OFFLINE: 1,
  NODE_CREATED: 2,
  GATEWAY_OFFLINE: 3,
  GATEWAY_CREATED: 4,
  ALARM_CREATED: 5,
  ALARM_RAISED: 6,
  ALARM_ACKNOWLEDGED: 7,
};

export const ActionResourceTypeEnum = {
  NODE: 0,
  USER: 1,
  COMPANY: 2,
  GATEWAY: 3,
  ACTION: 4,
  ALARM: 5,
};

export const ActionTypeEnum = {
  EMAIL: 0,
  SMS: 1,
  ADD_TO_ACTION: 2,
  MQTT: 3,
};

export function actionEventTypeToString(actionEventType: number): string {
  switch (actionEventType) {
    case ActionEventTypeEnum.DATA_INGEST_ERROR:
      return "Data Ingest Error";
    case ActionEventTypeEnum.NODE_OFFLINE:
      return "Node Offline";
    case ActionEventTypeEnum.NODE_CREATED:
      return "Node Created";
    case ActionEventTypeEnum.GATEWAY_OFFLINE:
      return "Gateway Offline";
    case ActionEventTypeEnum.GATEWAY_CREATED:
      return "Gateway Created";
    case ActionEventTypeEnum.ALARM_CREATED:
      return "Alarm Created";
    case ActionEventTypeEnum.ALARM_RAISED:
      return "Alarm Raised";
    case ActionEventTypeEnum.ALARM_ACKNOWLEDGED:
      return "Alarm Acknowledged";
    default:
      return "Unknown";
  }
}

export function actionTypeValues(actionType: number): string {
  switch (actionType) {
    case ActionTypeEnum.EMAIL:
      return "email";
    case ActionTypeEnum.SMS:
      return "sms";
    case ActionTypeEnum.ADD_TO_ACTION:
      return "add to action";
    case ActionTypeEnum.MQTT:
      return "mqtt";
    default:
      return "Unknown";
  }
}

export function getActionResourceType(actionEventType: number): number {
  switch (actionEventType) {
    case ActionEventTypeEnum.NODE_OFFLINE:
    case ActionEventTypeEnum.DATA_INGEST_ERROR:
      return ActionResourceTypeEnum.NODE;

    case ActionEventTypeEnum.ALARM_ACKNOWLEDGED:
    case ActionEventTypeEnum.ALARM_RAISED:
      return ActionResourceTypeEnum.ALARM;

    case ActionEventTypeEnum.GATEWAY_OFFLINE:
      return ActionResourceTypeEnum.GATEWAY;

    case ActionEventTypeEnum.NODE_CREATED:
    case ActionEventTypeEnum.GATEWAY_CREATED:
    case ActionEventTypeEnum.ALARM_CREATED:
      return ActionResourceTypeEnum.ACTION;

    default:
      return ActionResourceTypeEnum.ACTION;
  }
}
